export const BACKEND_BASE_URL = 'http://localhost:5000'
export const RESOURCES_LANGUAGES = {
  'tr': {
    name: 'Türkisch'
  },
  'ar': {
    name: 'Arabisch'
  },
  'pr': {
    name: 'Persisch'
  }
}

export const SURE_BOOK_21_REDIRECTIONS = {
  1: 'https://peertube.giz.berlin/videos/watch/11e9185c-d09a-4a43-8974-3bd3ad1de746',
  2: 'https://peertube.giz.berlin/videos/watch/cd68d86d-7a84-42a3-b5c8-aa87eeed45a9',
  3: 'https://peertube.giz.berlin/videos/watch/d845e543-7ddb-4bc9-9833-5c524ff9b9d4',
  4: 'https://peertube.giz.berlin/videos/watch/c1adf0ca-b3b6-49fd-bcc0-236b6b5a60c9',
  5: 'https://peertube.giz.berlin/videos/watch/940ec666-0c45-4fc3-afcc-5761dcf51518',
  6: 'https://peertube.giz.berlin/videos/watch/3d4da4f9-9b8c-43e6-adea-51dbba896612',
  7: 'https://peertube.giz.berlin/videos/watch/5dd1e286-1c06-4bbd-8e5f-449928f8c916',
  8: 'https://peertube.giz.berlin/videos/watch/ee257919-6145-4371-b516-1c8166069c25',
  9: 'https://peertube.giz.berlin/videos/watch/f4d2ce1d-1394-4fbc-9195-8d81736f4e62',
  10: 'https://peertube.giz.berlin/videos/watch/3392dc6b-a626-4e12-9aa7-1f276556a5ce',
  11: 'https://peertube.giz.berlin/videos/watch/9ad7fed7-24d1-496a-b128-255b1d8b9fae',
  12: 'https://peertube.giz.berlin/videos/watch/ffe5abb5-e1e6-4ee0-82d8-4ba52544d03d',
  13: 'https://peertube.giz.berlin/videos/watch/1de614ab-0b4b-41b7-8384-125d499ba941',
  14: 'https://sure.giz.berlin/about'
}

export const KASA_BOOK_21_REDIRECTIONS = {
  'zimmer_situationsansatz': 'https://peertube.giz.berlin/videos/watch/a8f86bbd-c3dd-47fd-9d01-202be884c3de',
  'zimmer_lernort': 'https://peertube.giz.berlin/videos/watch/8b81339a-39f7-42bf-a6d9-b5497ee30f0e',
  'zimmer_muttersprache': 'https://peertube.giz.berlin/videos/watch/9255d756-39fc-43f0-bd46-5f12a21be22f',
  'zimmer_alphabetisierung': 'https://peertube.giz.berlin/videos/watch/2c93d4d0-8401-4839-baab-6695dd204fdf',
  'abcami_visuelles_gedicht': 'https://peertube.giz.berlin/videos/watch/9a8aac8f-43ff-40bc-9765-e719eb78051a',
  'kasa_erklaervideo': 'https://peertube.giz.berlin/videos/watch/c8241179-2ceb-4d9f-9c4d-10b8b9fd9a0f',
  'grammatikvideos': 'https://peertube.giz.berlin/w/p/3TpAxi2kDDXWkqFWwLD3VN'
}

export const FILE_TYPE_MAP = {
  'text': {
    name: 'Text',
    extensions: [
      'pdf',
      'txt'
    ]
  },
  'audio': {
    name: 'Audio',
    extensions: [
      'wav',
      'mp3',
      'ogg'
    ]
  },
  'pictures': {
    name: 'Bilder',
    extensions: [
      'jpg',
      'png',
      'svg'
    ]
  },
  'video': {
    name: 'Video',
    extensions: [
      'peertubeId'
    ]
  }
}



// WEBPACK FOOTER //
// ./src/constants.js